import React, { useEffect, useState } from "react";
import api from "../api";
import ManagerProductCard from "../components/ProductCard";
import { useMemo } from "react";
import ProductFilters from "../components/ProductFilters/ProductFilters";
import BottomSheet from "../components/BottomSheet/BottomSheet";
import { FilterTypeFullRenderer } from "../components/ProductFilters/FilterTypesFull";
import { mapFilterType } from "../components/ProductFilters/FilterHelpers";
import './scss/manager-products.scss';
import FilterLenta from "../components/ProductFilters/FilterLenta";
import ProductCards from "../components/ProductCards/ProductCards";
import { useNavigate } from "react-router-dom";
import mapProduct from "../utils/mapProduct";
import BackButton from "../components/BackButton";
import Breadcrumbs from "../components/Breadcrumbs";
import LoadingScreen from "../components/Loading/LoadingScreen";
const STATIC_FILTERS = [
  //{ key: "category", label: "Категория", type: "Category" },
  { key: "delivery", label: "Срок доставки", type: "Delivery" },
  { key: "price", label: "Цена", type: "Number" },
  { key: "rating", label: "Рейтинг", type: "Static" }
];
export default function ManagerProductsPage() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [total, setTotal] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState(null);
  const [subcategory, setSubcategory] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");
  // фильтры
  const [dynamicFilters, setDynamicFilters] = useState([]);
  const [filters, setFilters] = useState({});
  const [activeFilter, setActiveFilter] = useState(null);
  const [showLenta, setShowLenta] = useState(false);

  const [page, setPage] = useState(1);
  const take = 10;

  const [loading, setLoading] = useState(false);

  const skip = (page - 1) * take;
  const totalPages = Math.ceil(total / take);
  function handleProductPress(id) {
    navigate(`/manager/product/${id}`);
  }
  useEffect(() => {
    load();
  }, [page, search, filters, statusFilter]);

  useEffect(() => {
    api.get("/api/manager/filter")
      .then(r => setDynamicFilters(r.data))
      .catch(() => setDynamicFilters([]));
  }, []);

  const normalizedDynamicFilters = useMemo(() => {
    return dynamicFilters.map(f => ({
      key: f.key,
      label: f.name,
      type: mapFilterType(f.type),
      values: f.values ?? [],
      meta: f
    }));
  }, [dynamicFilters]);

  async function load() {
    setLoading(true);

    try {
      const dynamic = [];

      dynamicFilters.forEach(df => {
        const value = filters[df.key];
        if (!value) return;

        if (Array.isArray(value) && value.length === 0) return;

        dynamic.push({
          filterId: df.key,
          values: Array.isArray(value) ? value : [value]
        });
      });

      const { data } = await api.post("/api/manager/products/search", {
        search,
        skip,
        take,
        status: statusFilter,
        dynamicFilters: dynamic,
        priceFrom: filters.price?.from,
        priceTo: filters.price?.to,
        ratingFrom: filters.rating,
        delivery: filters.delivery
      });

      setProducts(data.products);
      setTotal(data.total);

    } finally {
      setLoading(false);
    }
  }

  const availableFilters = useMemo(() => {
    const staticFilters = STATIC_FILTERS.map(f => {
      if (f.key === "category" && subcategory?.name) {
        return {
          ...f,
          label: subcategory.name
        };
      }
      return f;
    });

    return [
      ...staticFilters,
      ...normalizedDynamicFilters
    ];
  }, [
    normalizedDynamicFilters,
    subcategory?.id,
    subcategory?.name
  ]);

  useEffect(() => {
    if (page > totalPages && totalPages > 0) {
      setPage(totalPages);
    }
  }, [totalPages]);

  function getPages() {
    if (totalPages <= 1) return [];

    const delta = 2;
    const pagesSet = new Set();

    for (
      let i = Math.max(1, page - delta);
      i <= Math.min(totalPages, page + delta);
      i++
    ) {
      pagesSet.add(i);
    }

    pagesSet.add(1);
    pagesSet.add(totalPages);

    const sorted = [...pagesSet].sort((a, b) => a - b);

    const result = [];
    for (let i = 0; i < sorted.length; i++) {
      if (i > 0 && sorted[i] - sorted[i - 1] > 1) {
        result.push("ellipsis-" + i);
      }
      result.push(sorted[i]);
    }

    return result;
  }

  return (
    <>
      <div className="manager-products">
        <BackButton />

        <Breadcrumbs
          items={[
            { label: "Главная", path: "/manager/dashboard" },
            { label: "Товары" }
          ]}
        />
        <div className="manager-products__header">
          <input
            placeholder="Поиск товаров"
            value={searchInput}
            onChange={e => setSearchInput(e.target.value)}

            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setPage(1);
                setSearch(searchInput.trim());
              }
            }}

            onBlur={() => {
              setPage(1);
              setSearch(searchInput.trim());
            }}
          />
        </div>
        <ProductFilters
          value={filters}
          filters={availableFilters}
          onChange={(next) => {
            setPage(1);
            setFilters(next);
          }}
          onOpenLenta={() => setShowLenta(true)}
          onOpenFilter={(filterKey) => {
            const filter = availableFilters.find(f => f.key === filterKey);
            if (filter) {
              setActiveFilter(filter);
            }
          }}
          sortActive={false}
          onToggleSort={() => { }}
        />
        <div className="manager-products__switcher">
          <button
            className={statusFilter === "all" ? "active" : ""}
            onClick={() => {
              setPage(1);
              setStatusFilter("all");
            }}
          >
            Все
          </button>

          <button
            className={statusFilter === "approved" ? "active" : ""}
            onClick={() => {
              setPage(1);
              setStatusFilter("approved");
            }}
          >
            Активные
          </button>

          <button
            className={statusFilter === "cancel" ? "active" : ""}
            onClick={() => {
              setPage(1);
              setStatusFilter("cancel");
            }}
          >
            Заблокированные
          </button>
        </div>
        <div className="manager-products__list">
          {loading ? (<LoadingScreen />) : (<ProductCards
            products={products.map(mapProduct)}
            layout="grid"
            showViewAll={false}
            showCount={true}
            count={total}
            sectionTitle="Товары"
            onProductPress={handleProductPress}
          />)}

        </div>
        {totalPages > 1 && (
          <div className="manager-products__pagination">
            {getPages().map((p, i) =>
              typeof p === "string" ? (
                <span key={p}>...</span>
              ) : (
                <button
                  key={`page-${p}`}
                  className={page === p ? "active" : ""}
                  onClick={() => setPage(p)}
                >
                  {p}
                </button>
              )
            )}
          </div>
        )}

      </div>
      {activeFilter && (
        <BottomSheet
          open={true}
          header={activeFilter.label}
          closeButtomShow={true}
          onClose={() => setActiveFilter(null)}
        >
          <FilterTypeFullRenderer
            filter={activeFilter}
            value={filters[activeFilter.key]}
            onChange={(nextValue) => {
              setFilters(prev => ({
                ...prev,
                [activeFilter.key]: nextValue
              }));
            }}
            onOpenFull={() => { }}
          />
        </BottomSheet>
      )}
      <BottomSheet
        open={showLenta}
        header="Фильтры"
        closeButtomShow={true}
        onClose={() => setShowLenta(false)}
      >
        <FilterLenta
          filters={availableFilters}
          values={filters}
          onChange={(next) => {
            setPage(1);
            setFilters(next);
          }}
          onOpen={(filter) => {
            setActiveFilter(filter);
            setShowLenta(false);
          }}
          onClear={(key) => {
            const next = { ...filters };
            delete next[key];
            setPage(1);
            setFilters(next);
          }}
        />
      </BottomSheet>

    </>
  );
}